import * as React from "react"
import { Radio, RadioGroup } from "informed"
import * as s from "./style.scss"

interface IProps {
    days: { value: number, description: string }[]
    initialDate: number
}


// Dynamic radio elements for the five days
export default ({ days, initialDate }: IProps) => (
    <RadioGroup field="date" initialValue={days[initialDate].value}>
        <div className={s.navDayTimeBlock}>
            <ul className={s.navList}>
                {days.map((value, index) => {
                    return (
                        <li className={s.radioTable} key={`days_${index}`}>
                            <Radio className={s.navRadio} id={`days_${index}`} value={value.value} />
                            <div className={s.radioLabelBox}>
                                <label htmlFor={`days_${index}`}>{value.description}</label>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    </RadioGroup>
)